// 数据分析设置的配置项  这里只是结构 值需要通过setConifg
export default {
    ex:{
        name:"ex",
        id: 1,
        headerText: $t('integration.anomaly_analysis'),
        check: false,
        icon: 'el-icon-s-marketing',
        title:$t('integration.anomaly_analysis'),
        // 分析方法 method
        type: 1,
        // 日期类型  way
        dateType:'',
        // 值
        timeValue: '',
        timeType: 'year',
        sWay: [
            {
                value: 0,
                label: $t('integration.statistics')
            },
            {
                value: 1,
                label: $t('integration.year_on_year')
            },
            {
                value: 2,
                label: $t('integration.month_on_month')
            },
        ],
        timeTypeArray: [
            {
                value: 0,
                label: $t('integration.year')
            },
            {
                value: 1,
                label: $t('integration.month')
            },
            {
                value: 2,
                label: $t('integration.day')
            },
        ]
    },
    alarm:{
        name:"alarm",
        id: 2,
        headerText: $t('integration.alarm_trigger_analysis'),
        check: false,
        type: 1,
        timeValue: '',
        timeType: 'daterange',
        icon: 'iconfont icon-baojing',
        title:$t('integration.alarm_trigger_analysis'),
        sWay: [
            {
                value: 0,
                label: $t('integration.statistics')
            },
            {
                value: 1,
                label: $t('integration.year_on_year')
            },
            {
                value: 2,
                label: $t('integration.month_on_month')
            },
        ],
        timeTypeArray: [
            {
                value: 0,
                label: $t('integration.year')
            },
            {
                value: 1,
                label: $t('integration.month')
            },
            {
                value: 2,
                label: $t('integration.day')
            },
        ]
    },
    normalAbnormal:{
        name:"normalAbnormal",
        id: 3,
        headerText: $t('integration.normal_and_abnormal_proportion_analysis'),
        
        check: false,
        type: 3,
        timeValue: '',
        icon: 'el-icon-pie-chart',
        title:$t('integration.normal_and_abnormal_proportion_analysis'),
        timeType: 'daterange',
        sWay: [
            {
                value:3,
                label:$t('integration.proportion')
            }
        ],
    },
}